import { makeStyles } from "@mui/styles";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { FcCancel } from "react-icons/fc";
import { AiOutlineEdit } from "react-icons/ai";
import { pathName } from "../helpers/pathName";

const useStyles = makeStyles({
  //   "& .value": {
  //  fontWeight: 700,
  //   },
});

const Card_allReservations = ({
  allReservations,
  filteredData,
  myReservations,
  myCabins,
}) => {
  const classes = useStyles();
  // const [data, setData] = useState([]);
  // console.log(window.location.pathname);
  const onEditClick = (row) => {
    //  setShowEditModal(true);
    //  setSelectedID(row);
    //  setUseEffect(true);
    // console.log(row);
  };
  const onCancelClick = (row) => {
    //  setShowCancelModal(true);
    //  setSelectedID(row);
    //  setUseEffect(true);
    // console.log(row);
  };
  // useEffect(() => {
  //   window.location.pathname === pathName.allReservations
  //     ? setData(allReservations)
  //     : window.location.pathname === pathName.myReservations
  //     ? setData(myReservations)
  //     : setData(myCabins);
  // }, [window.location.pathname]);

  // console.log(data);
  return (
    <main className="grid 600px:grid-cols-2 900px:hidden">
      {filteredData.length !== 0
        ? filteredData.map((card, index) => {
            return (
              <main
                key={card._id}
                className=" p-2 m-2 even:bg-primaryExtraLight odd:bg-white border-[1.5px] border-primary rounded-lg shadow-md odd:shadow-primaryMedium even:shadow-secondaryBgOpacity"
              >
                <section className="flex items-center justify-between">
                  <div className="flex items-center justify-center p-[2px] rounded-full w-9 h-9 bg-primary text-secondary font-semibold">
                    {index + 1}
                  </div>
                  <div className="text-medium italic">{card._id}</div>
                </section>
                <section
                  className="flex items-center justify-center font-semibold bg-clip-text text-transparent bg-gradient-to-r from-logo1 via-logo2
           via-logo3 via-logo4  via-logo7 to-logo8"
                >
                  {card.email}
                </section>
                <section>
                  <main className="mb-2 flex items-center justify-between">
                    <div className="">
                      <div className="text-xs text-greySteel -mb-[2px]">
                        Cabin Name
                      </div>
                      <div className="value">{card.cabinName.cabinName}</div>
                    </div>
                    <div className="">
                      <div className="text-xs text-greySteel -mb-[2px] flex items-center justify-end">
                        Day
                      </div>
                      <div className="value">
                        {format(new Date(card.day), "dd/MM/yyyy")}
                      </div>
                    </div>
                  </main>
                  <main className="flex items-center justify-between">
                    <div className="">
                      <div className="text-xs text-greySteel -mb-[2px]">
                        Start Time
                      </div>
                      <div className="value">
                        {format(new Date(card.startTime), "hh:mm a")}
                      </div>
                    </div>
                    <div className="">
                      <div className="text-xs text-greySteel -mb-[2px] flex items-center justify-end">
                        End Time
                      </div>
                      <div className="value">
                        {format(new Date(card.endTime), "hh:mm a")}
                      </div>
                    </div>
                  </main>
                </section>
              </main>
            );
          })
        : allReservations.map((card, index) => {
            return (
              // <>
              //   {/* <div>{JSON.stringify(card)}</div> */}
              //   <div>{JSON.stringify(card._id)}</div>
              //   <div>{JSON.stringify(card.cabinName.cabinName)}</div>
              //   <div>{JSON.stringify(card.startTime)}</div>
              // </>
              <main
                key={card._id}
                className=" p-2 m-2 even:bg-primaryExtraLight odd:bg-white border-[1.5px] border-primary rounded-lg shadow-md odd:shadow-primaryMedium even:shadow-secondaryBgOpacity"
              >
                {/* All Reservations */}
                {window.location.pathname === pathName.allReservations ? (
                  <section className="flex items-center justify-between">
                    <div className="flex items-center justify-center p-[2px] rounded-full w-9 h-9 bg-primary text-secondary font-semibold">
                      {index + 1}
                    </div>
                    <div className="text-medium italic">{card._id}</div>
                  </section>
                ) : null}

                {/* My Reservations */}
                {window.location.pathname === pathName.myReservations ? (
                  <section className="flex items-center justify-between">
                    <section className="flex items-center justify-start">
                      <div className="flex items-center justify-center p-[2px] rounded-full w-9 h-9 bg-primary text-secondary font-semibold">
                        {index + 1}
                      </div>
                      <div className="ml-2 text-medium italic">{card._id}</div>
                    </section>
                    <section className="flex items-center justify-center">
                      <div
                        id="edit"
                        className=""
                        onClick={() => onEditClick(card)}
                      >
                        <AiOutlineEdit className="w-[22px] h-[22px]" />
                        {/* <p className="edit">Edit</p> */}
                      </div>
                      <div onClick={() => onCancelClick(card)}>
                        <FcCancel className="w-[22px] h-[22px]" />
                        {/* <p className="cancel">cancel</p> */}
                      </div>
                    </section>
                    {/* <div className="text-medium italic">{card._id}</div> */}
                  </section>
                ) : null}

                {/* My Cabins */}
                {window.location.pathname === pathName.myCabins ? (
                  <section className="flex items-center justify-between">
                    <section className="flex items-center justify-start">
                      <div className="flex items-center justify-center p-[2px] rounded-full w-9 h-9 bg-primary text-secondary font-semibold">
                        {index + 1}
                      </div>
                      <div className="ml-2 text-medium italic">{card._id}</div>
                    </section>
                    <section className="flex items-center justify-center">
                      <div
                        id="edit"
                        className=""
                        onClick={() => onEditClick(card)}
                      >
                        <AiOutlineEdit className="w-[22px] h-[22px]" />
                        {/* <p className="edit">Edit</p> */}
                      </div>
                      <div onClick={() => onCancelClick(card)}>
                        <FcCancel className="w-[22px] h-[22px]" />
                        {/* <p className="cancel">cancel</p> */}
                      </div>
                    </section>
                    {/* <div className="text-medium italic">{card._id}</div> */}
                  </section>
                ) : null}

                <section
                  className="flex items-center justify-center font-semibold bg-clip-text text-transparent bg-gradient-to-r from-logo1 via-logo2
            via-logo3 via-logo4  via-logo7 to-logo8"
                >
                  {card.email}
                </section>
                <section>
                  <main className="mb-2 flex items-center justify-between">
                    <div className="">
                      <div className="text-xs text-greySteel -mb-[2px]">
                        Cabin Name
                      </div>
                      <div className="value">{card.cabinName.cabinName}</div>
                    </div>
                    <div className="">
                      <div className="text-xs text-greySteel -mb-[2px] flex items-center justify-end">
                        Day
                      </div>
                      <div className="value">
                        {format(new Date(card.day), "dd/MM/yyyy")}
                      </div>
                    </div>
                  </main>
                  <main className="flex items-center justify-between">
                    <div className="">
                      <div className="text-xs text-greySteel -mb-[2px]">
                        Start Time
                      </div>
                      <div className="value">
                        {format(new Date(card.startTime), "hh:mm a")}
                      </div>
                    </div>
                    <div className="">
                      <div className="text-xs text-greySteel -mb-[2px] flex items-center justify-end">
                        End Time
                      </div>
                      <div className="value">
                        {format(new Date(card.endTime), "hh:mm a")}
                      </div>
                    </div>
                  </main>
                </section>
              </main>
            );
          })}
    </main>
  );
};

export default Card_allReservations;
